query totalTrafficBySourceForCompany($input: TrafficCountInput) {
  totalTrafficBySourceForCompany: totalTrafficBySourceForCompany(input: $input) {
    source
    count
  }
}
